import { useRef, useEffect } from 'react';
import { memo } from 'react';

const NodeLabel = memo(
  function NodeLabel({
    value,
    onChange,
    className,
  }: {
    value: string;
    onChange: (val: string) => void;
    className?: string;
  }) {
    const ref = useRef<HTMLTextAreaElement>(null);

    useEffect(() => {
      if (!ref.current) return;
      ref.current.style.height = '0px';
      ref.current.style.height = `${ref.current.scrollHeight}px`;
    }, [value]);

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      onChange(e.target.value);
    };

    return (
      <textarea
        ref={ref}
        value={value}
        onChange={handleChange}
        className={
          'nodrag w-100 resize-none border-none outline-none bg-transparent text-xs text-center overflow-hidden p-0 m-0 ' +
          className
        }
        style={{
          boxSizing: 'border-box',
          lineHeight: '1.2',
          userSelect: 'none',
        }}
      />
    );
  },
  (prev, next) =>
    prev.value === next.value &&
    prev.className === next.className &&
    prev.onChange === next.onChange
);
export default NodeLabel;
